import { SDK_CONSTANTS } from '@/shared/constants';

export const SDK = window.SDK;
export const { MFChannel, EIM } = SDK;
export const SDK_STATUS_CALL_STATUS = SDK_CONSTANTS.SDK_STATUS_CALL_STATUS;

export default SDK;
